import axios from 'axios';
import router from '@/router';
import { nextTick } from 'vue';
import { loadingShow, loadingHide } from "@/plugins/loadingControls";

const AUTH_SESSION_EXPIRED_EVENT = 'auth-session-expired';
const AUTH_SESSION_EXPIRED_MESSAGE = 'Tu sesión ha sido cerrada por inactividad. Inicia sesión nuevamente.';
let isRedirectingToLogin = false;
let hasNotifiedSessionExpired = false;

const currentHost = window.location.hostname;
const apiByHost = {
  'demo.tuscfdis.com': 'https://apidemo.tuscfdis.com',
  'app.tuscfdis.com': 'https://api.tuscfdis.com',
  'app.tuscfdis.site': 'https://api.tuscfdis.site',
  'localhost': 'http://api.tuscfdis.site',
};

let baseUrl = apiByHost[currentHost] || 'https://api.tuscfdis.com';

axios.defaults.baseURL = baseUrl;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'Application/json';

//Definir el token de autenticación
const token = localStorage.getItem('access_token');

if (!token || token === 'undefined') {
    axios.defaults.headers.common['Authorization'] = '';
} else {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const isUnauthorizedPayload = (payload) => {
  const type = String(payload?.type || '').toLowerCase();
  const message = String(payload?.message || '').toLowerCase();

  return (
    type === 'auth' ||
    type === 'auth_error' ||
    message.includes('no autorizado')
  );
}

const redirectToLoginByExpiredSession = async () => {
  if (isRedirectingToLogin) return;

  isRedirectingToLogin = true;
  localStorage.removeItem('access_token');
  axios.defaults.headers.common['Authorization'] = '';

  if (!hasNotifiedSessionExpired) {
    hasNotifiedSessionExpired = true;
    window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, {
      detail: {
        message: AUTH_SESSION_EXPIRED_MESSAGE,
      },
    }));
  }

  await nextTick();

  if (router.currentRoute.value?.name === 'login') {
    isRedirectingToLogin = false;
    return;
  }

  router.replace({
    name: 'login'
  }).finally(() => {
    isRedirectingToLogin = false;
  });
}

axios.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
})

axios.interceptors.response.use(async function (response) {
  const shouldHideLoading = !response.config?.skipLoading;

  if (isUnauthorizedPayload(response.data)) {
    if (shouldHideLoading) loadingHide();
    await redirectToLoginByExpiredSession();
    return Promise.reject(response.data);
    }
    if (shouldHideLoading) loadingHide();
    return response.data;
}, async function (error) {
    if(error.response !== undefined){
    if (error.response.status === 401 || isUnauthorizedPayload(error.response.data)) {
      if (!error.config?.skipLoading) loadingHide();
      await redirectToLoginByExpiredSession();
      return Promise.reject(error);
        } else if (error.response.status === 500 || error.response.status === 404 || error.response.status === 400) {
            if (!error.config?.skipLoading) loadingHide();
            throw error;
        } else {
            if (!error.config?.skipLoading) loadingHide();
            return Promise.reject(error);
        }
    }
    else{
        if (!error.config?.skipLoading) loadingHide();
        return Promise.reject(error);
    }
})

axios.interceptors.request.use(
  (config) => {
    const currentToken = localStorage.getItem('access_token');
    if (currentToken && currentToken !== 'undefined') {
      config.headers.Authorization = `Bearer ${currentToken}`;
    } else if (config.headers?.Authorization) {
      delete config.headers.Authorization;
    }

    if (!config.skipLoading && config.url !== undefined && !config.url.endsWith('check-downloads') && !config.url.endsWith('get-fields') && !config.url.endsWith('get-filters')) {
      loadingShow({ text: config.loadingText || "Cargando..." });
    }
    return config;
  },
  (error) => {
    loadingHide();
    return Promise.reject(error);
  }
);

